import React, { ReactElement, useCallback, useState } from "react";
import cx from "classnames";

// styles
import styles from "../styles/FoodItem.scss";
import { InputQty } from "../styles/ItemQty";

// test ids
import { QTY_INPUT_TEST_IDS } from "@swiggy-private/cart-test-ids";

// constants
import { TEXTS } from "@cart-ui/constants/ItemQty";
import { QTY_CHANGE_ACTION_TYPE, MAX_INPUT_QTY } from "../constants";

interface ItemQtyProps {
    className?: string;
    onQuantityChange: (action: QTY_CHANGE_ACTION_TYPE, qty?: number) => void;
    quantity: number;
    updating: boolean;
    isQtyBeingEdited: boolean;
    setIsQtyBeingEdited: (value: boolean) => void;
    removeItem: VoidFunction;
}

export const ItemQty = React.memo(function AddButton(props: ItemQtyProps): ReactElement {
    const { onQuantityChange, isQtyBeingEdited, setIsQtyBeingEdited, removeItem, quantity, updating } = props;

    const [itemQty, setItemQty] = useState(quantity);

    const handleQtyChange = useCallback(e => {
        setItemQty(parseInt(e.target.value));
    }, []);

    const handleQtyFocus = useCallback(() => {
        setIsQtyBeingEdited(true);
    }, [setIsQtyBeingEdited]);

    const handleQtyBlur = useCallback(() => {
        if (itemQty < 1) {
            removeItem();
            setIsQtyBeingEdited(false);
            return;
        }
        onQuantityChange(QTY_CHANGE_ACTION_TYPE.QTY_CHANGE, itemQty);
        setIsQtyBeingEdited(false);
    }, [itemQty, removeItem, setIsQtyBeingEdited, onQuantityChange]);

    return (
        <div
            className={cx(styles.qtyInputContainer, {
                [styles.qtyInputContainerIsEditing]: isQtyBeingEdited,
            })}
        >
            <input
                className={styles.qtyInputField}
                type="tel"
                value={itemQty || ""}
                onChange={handleQtyChange}
                onFocus={handleQtyFocus}
                onBlur={handleQtyBlur}
                data-testid={QTY_INPUT_TEST_IDS.INPUT}
                maxLength={MAX_INPUT_QTY}
            />
            <div className={styles.qtyInputContent}>
                <div className={styles.qtyInputContainerDivider} />
                <InputQty variant="V2.body2.neutral.medium" color="text_Low_Emphasis">
                    {TEXTS.QTY}
                </InputQty>
            </div>
            {updating && <div className={styles.addButtonContainerLoader} />}
        </div>
    );
});
